import type { ParagraphFeatures4Col as ParagraphFeatures4ColData } from "@/lib/api/cms-catalog";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import { HtmlText } from "../shared/HtmlText";
import styles from "./ParagraphFeatures4Col.module.css";

/**
 * Layout 48 - `PARAGRAPH_FEATURES_4COL_LAYOUT`: features 4-col.
 *
 * Struktura:
 *   - H2 tytul sekcji (left-aligned)
 *   - Optional lead (HTML z TinyMCE, muted, pod tytulem)
 *   - Grid 4 kart w rzedzie {icon (Nucleo w mint pill), name, desc}
 *   - Puste karty (bez name i bez desc) filtrowane po backendzie
 *
 * Wariant why-us (39) kompaktowy do jednego rzedu.
 */
export function ParagraphFeatures4Col({
  paragraph,
  t: _t,
}: {
  paragraph: ParagraphFeatures4ColData;
  t: ParagraphTranslations;
}) {
  const { name: title, text: lead, items } = paragraph;
  const hasLead = lead && lead.trim() !== "";
  const hasItems = Array.isArray(items) && items.length > 0;

  return (
    <section className={styles.section}>
      <div className={styles.header}>
        {title ? <h2 className={styles.title}>{title}</h2> : null}
        {hasLead ? (
          <HtmlText html={lead} className={styles.lead} />
        ) : null}
      </div>

      {hasItems ? (
        <div className={styles.grid}>
          {items.map((it, idx) => (
            <div key={idx} className={styles.card}>
              {it.icon ? (
                <div className={styles.iconBox} aria-hidden="true">
                  <i className={`nc-icon-outline ${it.icon}`} />
                </div>
              ) : null}
              {it.name ? <h3 className={styles.name}>{it.name}</h3> : null}
              {it.desc ? <p className={styles.desc}>{it.desc}</p> : null}
            </div>
          ))}
        </div>
      ) : null}
    </section>
  );
}
